/**
 * Infinity Collectables – Card Overlay Actions  v2
 * ─────────────────────────────────────────────────
 * 1) AJAX add-to-cart for [data-ic-add] icon buttons
 * 2) Cart drawer / notification refresh (Dawn 9+)
 * 3) Dot-slider sync for .slider-counter--dots pagination
 * 4) Inline toast for error feedback
 *
 * Loaded via layout/theme.liquid (defer)
 */
(function () {
  'use strict';

  /* ────────────────────────────────────────────────────────────
     1. AJAX ADD-TO-CART
     Listens for clicks on any [data-ic-add][data-variant-id]
  ──────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ic-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    // Prevent double-clicks
    if (btn.disabled) return;
    btn.disabled = true;

    // Show loading state
    var origHTML = btn.innerHTML;
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" style="animation:ic-spin 0.6s linear infinite">' +
      '<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" stroke-dasharray="28" stroke-dashoffset="10"/>' +
      '</svg>';

    fetch('/cart/add.js', {
      method:      'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept':        'application/json',
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (d) {
            throw new Error(d.description || d.message || 'Could not add to cart');
          });
        }
        return res.json();
      })
      .then(function () {
        // ✔ Success: show check-mark for 1.2 s
        btn.classList.add('is-added');
        btn.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.5"' +
          ' stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>';

        // Refresh Dawn cart UI
        refreshCart();

        setTimeout(function () {
          btn.innerHTML = origHTML;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1200);
      })
      .catch(function (err) {
        btn.innerHTML = origHTML;
        btn.disabled = false;
        showToast(err.message || 'Could not add to cart — please try again.');
      });
  });

  /**
   * Trigger Dawn's cart drawer / notification to refresh.
   * Covers Dawn 8 (cart-notification) and Dawn 9+ (cart-drawer with PubSub).
   */
  function refreshCart() {
    // Method 1: PubSub event (Dawn 9+)
    if (window.PubSub && typeof window.PubSub.publish === 'function') {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          window.PubSub.publish('cart:updated', { cart: cart });
        })
        .catch(function () {});
    }

    // Method 2: Dawn 9 cart-drawer custom element
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Dawn listens for this document event to open + refresh the drawer
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:open', { bubbles: true })
          );
        })
        .catch(function () {});
      return;
    }

    // Method 3: Dawn 8 cart-notification
    var cartNotif = document.querySelector('cart-notification');
    if (cartNotif && typeof cartNotif.renderContents === 'function') {
      cartNotif.renderContents({});
    }
  }

  /* ────────────────────────────────────────────────────────────
     2. DOT-SLIDER SYNC
     Attaches to every .slider-counter--dots found in the DOM.
     Re-runs on Shopify theme editor section reload.
  ──────────────────────────────────────────────────────────── */
  function initDotSliders() {
    document.querySelectorAll('.slider-counter--dots').forEach(function (dotsEl) {
      // Guard: only init once
      if (dotsEl.dataset.icDotInit) return;
      dotsEl.dataset.icDotInit = '1';

      var sliderComp = dotsEl.closest('slider-component');
      var sliderList = sliderComp
        ? sliderComp.querySelector('[id^="Slider-"]')
        : null;
      if (!sliderList) return;

      var dots = Array.from(dotsEl.querySelectorAll('.slider-counter__link'));
      if (!dots.length) return;

      // Dot click → scroll to slide
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx    = parseInt(dot.getAttribute('data-slide-index') || '0', 10);
          var slides = sliderList.querySelectorAll('.slider__slide');
          if (!slides[idx]) return;
          slides[idx].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
          setActiveDot(dots, idx);
        });
      });

      // Scroll → update active dot
      sliderList.addEventListener(
        'scroll',
        debounce(function () {
          var slides       = sliderList.querySelectorAll('.slider__slide');
          if (!slides.length) return;
          var containerLeft = sliderList.getBoundingClientRect().left;
          var current       = 0;
          var minDist       = Infinity;
          Array.from(slides).forEach(function (slide, i) {
            var dist = Math.abs(slide.getBoundingClientRect().left - containerLeft);
            if (dist < minDist) { minDist = dist; current = i; }
          });
          setActiveDot(dots, current);
        }, 80),
        { passive: true }
      );
    });
  }

  function setActiveDot(dots, idx) {
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === idx);
      d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
    });
  }

  /* ────────────────────────────────────────────────────────────
     3. INLINE TOAST (no dependencies)
  ──────────────────────────────────────────────────────────── */
  function showToast(message) {
    var existing = document.getElementById('ic-toast');
    if (existing) existing.remove();

    var toast     = document.createElement('div');
    toast.id      = 'ic-toast';
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = message;
    Object.assign(toast.style, {
      position:     'fixed',
      bottom:       '2rem',
      left:         '50%',
      transform:    'translateX(-50%)',
      background:   '#0f172a',
      color:        '#fff',
      padding:      '1.1rem 2rem',
      borderRadius: '999px',
      fontSize:     '1.4rem',
      fontWeight:   '600',
      zIndex:       '99999',
      pointerEvents:'none',
      boxShadow:    '0 8px 28px rgba(15,23,42,.35)',
      opacity:      '0',
      transition:   'opacity 200ms ease',
      whiteSpace:   'nowrap',
    });

    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.style.opacity = '1'; });
    });
    setTimeout(function () {
      toast.style.opacity = '0';
      setTimeout(function () { toast.remove(); }, 250);
    }, 2500);
  }

  /* ────────────────────────────────────────────────────────────
     4. SPIN KEYFRAME (injected once)
  ──────────────────────────────────────────────────────────── */
  (function injectSpinKeyframe() {
    if (document.getElementById('ic-spin-style')) return;
    var s = document.createElement('style');
    s.id  = 'ic-spin-style';
    s.textContent = '@keyframes ic-spin { to { transform: rotate(360deg); } }';
    document.head.appendChild(s);
  })();

  /* ────────────────────────────────────────────────────────────
     UTILITIES
  ──────────────────────────────────────────────────────────── */
  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  /* ────────────────────────────────────────────────────────────
     INIT
  ──────────────────────────────────────────────────────────── */
  function init() {
    initDotSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when theme editor reloads a section
  document.addEventListener('shopify:section:load', function () {
    // Remove init guard so re-attaches cleanly
    document.querySelectorAll('[data-ic-dot-init]').forEach(function (el) {
      delete el.dataset.icDotInit;
    });
    initDotSliders();
  });

})();
